import type { Entry } from '../services/entries';

/**
 * "2 ארוחות · 7 פריטים" למסך הליווי. כל מרכיב נשמר כרישום נפרד (מדיניות היומן), ולכן מספר הרישומים
 * אינו מספר הארוחות — צלחת של 4 רכיבים הוצגה כ"4 ארוחות תועדו" (ביקורת 29.09). ארוחה = סוג ארוחה
 * שיש בו לפחות רישום אחד (בלי סוג → נשנוש); פריט = כל פריט ברישום (רישום ישן מרובה-פריטים נספר לפי פריטיו).
 */
export function mealCountText(entries: Pick<Entry, 'meal_type' | 'items'>[]): string {
  const meals = new Set(entries.map((e) => e.meal_type ?? 'snack')).size;
  const items = entries.reduce((n, e) => n + Math.max(1, e.items?.length ?? 0), 0);
  const m = meals === 1 ? 'ארוחה אחת' : `${meals} ארוחות`;
  const i = items === 1 ? 'פריט אחד' : `${items} פריטים`;
  return `${m} · ${i}`;
}
